var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},_vm._l((_vm.code),function(c,i){return _c('div',{key:'code'+i,staticClass:"icon"},[_c('img',{attrs:{"src":_vm.icon[c['@call']]}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }